import { Component, computed, inject, signal } from '@angular/core';
import { AuditEntityType, ModalActions } from '../../../../core/enums/base.enums';
import { BootstrapService } from '../../../../core/services/bootstrap.service';
import { PropertyChargeModel } from '../../../../core/models/data/property-charge.model';
import { AuditLogsComponent } from '../../../../parts/audit-logs/audit-logs.component';
import { EscCloseDirective } from '../../../../core/directives/esc-close.directive';

@Component({
	selector: 'ms-invoice-log-modal',
	imports: [AuditLogsComponent, EscCloseDirective],
	templateUrl: './invoice-log-modal.component.html',
	styleUrl: './invoice-log-modal.component.scss'
})
export class InvoiceLogModalComponent {

	//#region Properties & Signals

	private bootstrapService = inject(BootstrapService);

	public charge = signal<PropertyChargeModel | undefined>(undefined);
	public isOpen = signal<boolean>(false);
	public chargeId = computed(() => this.charge()?.propertyChargeId);

	public AuditEntityType = AuditEntityType;

	//#endregion Properties & Signals

	//#region Public Methods

	public open(charge: PropertyChargeModel): void {
		this.charge.set(charge);
		this.isOpen.set(true);
		this.bootstrapService.manageModal('#invoiceLogModal', ModalActions.Show);
	}

	public close(): void {
		this.isOpen.set(false);
		this.bootstrapService.manageModal('#invoiceLogModal', ModalActions.Hide);
	}

	//#endregion Public Methods
}
